import {  
  loadPermissionDataInProgress,
  loadRoleAdminDataSuccess,
  loadPermissionDataFailure,
  loadRolePermissionsDataSuccess,
  loadPermissionsDataSuccess,
  permissionsOperationCompleted,
} from "../state/permissions/actions";
import configData from "../config.json";
import swal from 'sweetalert';
import { errorSweetAlert, oopsSweetAlert } from '../components/SweetAlertMessages';
import { getUserPermissionRolesData } from "./userpermissionsapi";
import { oktaAuth } from '../auth/okta';
const serverBasePath=configData.SERVER_API_URL;

export const loadRolesList = ( previousController) => async (dispatch) => {
  const token = oktaAuth.getAccessToken();
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadPermissionDataInProgress());
    const response = await fetch(serverBasePath+"/permission/adminRoles",
      { 
        method: "GET",
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json',
      }});

      if(response.status===401){
        window.location.reload(false);
        return;
      }
     const data = await response.json();
     dispatch(loadRoleAdminDataSuccess(data));
  } catch (e) {       
    dispatch(loadPermissionDataFailure());
    errorSweetAlert(e);
  }
};


export const loadPermissionsList = () => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    try {
      //dispatch(loadAccessDataInProgress());
      dispatch(loadPermissionDataInProgress());
      const response = await fetch(serverBasePath+"/permission/list",
      {
          method: "GET",
          headers: {
          Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
          }
      });
  
        if(response.status===401){
          window.location.reload(false);
          return;
        }
       const data = await response.json();
       dispatch(loadPermissionsDataSuccess(data));
    } catch (e) {    
     // dispatch(loadAccessDataFailure());
      dispatch(loadPermissionDataFailure());
      errorSweetAlert(e)
    }
  };


export const loadRolePermissionsList = (roleId) => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    try {
      dispatch(loadPermissionDataInProgress());
      const response = await fetch(serverBasePath+"/permission/role/"+roleId,{
          method: "GET",
          headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
          }});
  
        if(response.status===401){
          window.location.reload(false);
          return;
        }
       const data = await response.json();
      
       dispatch(loadRolePermissionsDataSuccess(data));
      // dispatch(loadDataSuccess(data));
    } catch (e) {       
      dispatch(loadPermissionDataFailure());
      errorSweetAlert(e);
    }
  };


  export const updateRolePermissions = (roleId,permissions) => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    let data = {
      'roleId' : roleId,
      'permissions' : permissions
    }
    dispatch(loadPermissionDataInProgress());
    try {
        const response = await fetch(serverBasePath+"/permission/updatepermissions", 
        {
            method: "PUT",  
            headers: {
              Authorization: 'Bearer ' + token,       
              'Content-Type': 'application/json',
            },
            body:JSON.stringify(data)
        });
        dispatch(permissionsOperationCompleted());
        const result = await response.json();
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        swal({
            title: "Success",
            text: result.message,
            icon: "success",
            closeOnClickOutside:false,
            closeOnEsc: false,
            allowOutsideClick: false,
        }).then(marked => {
          if (marked) {
            dispatch(loadRolePermissionsList(roleId));
            dispatch(getUserPermissionRolesData());
          }
        });
    } catch (e) {
        dispatch(loadPermissionDataFailure());
        errorSweetAlert(e);
    }
  };